import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {AdvancedSearchStore} from './advanced-search.store';
import { HttpClient } from '@angular/common/http';
import { ConstantsStore } from '../constants.store';

@Injectable({
  providedIn: 'root'
})
export class AdvancedSearchService {

  // searchRequested = new Subject();

  constructor(
    private store: AdvancedSearchStore,
    private http: HttpClient,
    private constants: ConstantsStore
  ) { }

  public getIsinList() {
    if (!this.store.autocompleteValues) {
      return new Promise((resolve, reject) => {
        this.httpGet()
          .toPromise()
          .then(
            (res: {[key: string]: string}) => {
              this.store.autocompleteValues = res;
              resolve(true);
            }
          )
          .catch(err => {
              reject(err);
            }
          );
      });
    }
  }

  public getVisibleIsinList() {
      return this.httpGetVisible()
          .toPromise();
  }

  private httpGetVisible() {
    return this.http.get<{[key: string]: string}>(this.constants.visibleIsinListUrl);
  }
  private httpGet() {
    return this.http.get<{[key: string]: string}>(this.constants.isinListUrl);
  }

  // get(pageNum: number = 1, pageSize: number = 10, queryParams: AdvancedSearchResult, filter: string = null, ascending: boolean = null): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.tableService.getAdvancedSearchTableRecords(pageNum, pageSize, queryParams, filter, ascending)
  //       .toPromise()
  //       .then(
  //         (res: TableObject<AdvancedSearchResult>) => {
  //           this.store.totalRecords = res.totalRecords;
  //           this.store.load(res.records);
  //           resolve(res.records);
  //         }
  //       )
  //       .catch(err => {
  //           reject(err);
  //         }
  //       );
  //   });
  // }

  // getDropdownValues(): Promise<boolean> {
  //   return new Promise((resolve, reject) => {
  //     this.tableService.getDropdownValues()
  //       .toPromise()
  //       .then(
  //         (res: {[key: string]: string}) => {
  //           this.store.dropDownValues = res;
  //           resolve(true);
  //         }
  //       )
  //       .catch(err => {
  //           reject(err);
  //         }
  //       );
  //   });
  // }

  // sorting(sort: Sort) {
  //   const data = this.store.records.slice();

  //   if (!sort.active || sort.direction === '') {
  //     this.store.sortedRecords = data;
  //     return;
  //   }

  //   this.store.sortedRecords = data.sort((a, b) => {
  //     const isAsc = sort.direction === 'asc';
  //     switch (sort.active) {
  //       case 'Isin': return this.compare(a.isin, b.isin, isAsc);
  //       case 'Emittente': return this.compare(a.emittente, b.emittente, isAsc);
  //       case 'Categoria': return this.compare(a.categoria, b.categoria, isAsc);
  //       case 'Nome': return this.compare(a.nome, b.nome, isAsc);
  //       case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
  //       case 'Strike': return this.compare(a.strike, b.strike, isAsc);
  //       case 'Prezzo': return this.compare(a.prezzoriferimento, b.prezzoriferimento, isAsc);
  //       case 'Mercato': return this.compare(a.mercato, b.mercato, isAsc);
  //       case 'Barriera': return this.compare(a.barriera, b.barriera, isAsc);
  //       case 'Cadenza': return this.compare(a.cadenza, b.cadenza, isAsc);
  //       case 'Cedola': return this.compare(a.cedola, b.cedola, isAsc);
  //       case 'Scadenza': return this.compare(a.scadenza, b.scadenza, isAsc);
  //       default: return 0;
  //     }
  //   });
  // }

  // compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  //   return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  // }
}
